import LolRegionSelectorBanner from "@core-components/regionSelector/banner/LolRegionSelectorBanner";
import type { AppLolRegion } from "@core-types/region.enum";
import { SimpleGrid } from "@mantine/core";
import type ISkin from "../models/ISkin.model";
import FadeUp from "./FadeUp";
import SkinLinkCard from "./SkinLinkCard";

interface Props {
  skins: ISkin[];
  championSlug: string;
  onRegionChange?: (region: AppLolRegion) => void;
}

const SkinCardGrid: React.FC<Props> = ({
  skins,
  championSlug,
  onRegionChange,
}) => {
  return (
    <div>
      <LolRegionSelectorBanner
        className="!ml-0 mb-8"
        onRegionChange={onRegionChange}
      />

      <SimpleGrid
        className="w-full"
        cols={{ base: 1, sm: 2, md: 3, lg: 3, xl: 4 }}
        spacing={50}
      >
        {skins.map((skin) => (
          <FadeUp key={skin.slug}>
            <SkinLinkCard championSlug={championSlug} skin={skin} />
          </FadeUp>
        ))}
      </SimpleGrid>
    </div>
  );
};

export default SkinCardGrid;
